// extracted by mini-css-extract-plugin
export var buttonContainer = "_5s-1";
export var fontSizeSelect = "_5s-3";
export var formatSelect = "_5s-2";
export var formats = "_5s-4";
export var hidden = "_5s-5";
export var icon = "_5s-6";
export var select = "_5s-0";